import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import {
  Alert,
  Icon,
  Layout,
  Badge,
  Table,
  Switch,
  Button,
  Modal,
  message,
  Tooltip,
} from "antd";
import moment from "moment";
import { withNamespaces } from "react-i18next";

import classes from "./QualityControl.css";

import isAuthenticated from "../../utils/isAuthenticated";
import { getSubjectIssuesList, getSitesRequest } from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getSubjectIssuesCreatePermission,
  getSubjectIssuesDeletePermission,
  getSubjectIssuesUpdatePermission,
} from "../../reducers/user/selectors";
import QualityControlForm from "../../components/QualityControlForm/QualityControlForm";
import { withParams } from "../../utils/url";
import { Link } from "react-router-dom";
import FormBuilderCustomViewContainer from "../FormBuilder/FormBuilderCustomViewContainer";

const routes = require("../../routes.json");

const { Content } = Layout;
// const { Search } = Input;

class QualityControl extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      customers: [],
      sites: [],
      formEvent: null,
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      site: null,
      order: "desc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: {},
      customerEdit: null,
      approvedSelected: null,
    };
  }

  async componentDidMount() {
    this.onNameSearch();

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  onNameSearch = async (value) => {
    this.setState({ nameSearch: value, eventsSelected: {}, currentPage: 1 }, this.getIssues);
  };

  getIssues = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getSubjectIssuesList({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
      });

      if (Array.isArray(data.data)) {
        this.setState({
          customers: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          customers: data,
          total: 1 * per_page,
          currentPage: page,
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        customers: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filter, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getIssues(pagination.current, pagination.pageSize)
    );
  };

  onRecordEdit = (item) => () => {
    this.setState({ customerEdit: item });
  };

  onRecordEditHide = () => {
    this.setState({ customerEdit: null });
  };

  onRecordEditSubmit = () => {
    this.setState({ customerEdit: null }, this.getIssues);
  };

  onEventEdit = (item) => () => {
    this.setState({ formEvent: item });
  };

  onEventEditHide = () => {
    this.setState({ formEvent: null });
  };

  onEventEditSubmit = () => {
    this.setState({ formEvent: null }, this.getIssues);
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, currentPage: 1 }, this.getIssues);
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      sites,
      customers,
      currentPage,
      total,
      pageSize,
      customerEdit,
      sortedInfo,
      formEvent,
    } = this.state;

    const columns = [
      {
        dataIndex: "event",
        key: "event",
        title: this.props.i18n.t("Event"),
        render: (val, item) => {
          return get(val, "name");
        },
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "event" && sortedInfo.order,
      },
      {
        dataIndex: "subject",
        key: "subject",
        title: this.props.i18n.t("Subject"),
        render: (val) => (
          <Link
            to={withParams(routes.admin.patientProfileSingle, {
              subjectID: get(val, "code"),
            })}
          >
            {get(val, "code")}
          </Link>
        ),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "subject" && sortedInfo.order,
      },
      {
        dataIndex: "status",
        key: "status",
        title: this.props.i18n.t("Status"),
        sorter: true,
        render: (val) => <Badge style={{ background: ["reviewed", "answered"].includes(val) ? "#49c850" : val === 'new' ? "#2968AE" : "#ccc" }} count={val} />,
        sortOrder:
          get(sortedInfo, "columnKey") === "status" && sortedInfo.order,
      },
      {
        dataIndex: "type",
        key: "type",
        title: this.props.i18n.t("Type"),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "type" && sortedInfo.order,
      },
      {
        dataIndex: "issue",
        key: "issue",
        title: this.props.i18n.t("Issue"),
        sorter: false,
        // maybe it would be better to show field: value pairs with errors
        //     "field_errors_data": {
        //         "sex": [
        //             "Value male not in accepted values ['female']."
        //         ],
        //         "birth_year": [
        //             "Value 1988.0 is not greater then 1990."
        //         ]
        //     },
        render: (val, item) => (get(item, 'error_description') || get(item, 'comments'))

      },
      {
        dataIndex: "created",
        key: "created",
        title: this.props.i18n.t("Users") + "/" + this.props.i18n.t("Created"),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "created" && sortedInfo.order,
        render: (val, item) => (
          <p>
            {!!item.created && (
              <span>
                {this.props.i18n.t('Created by')}:  {get(get(item, "created_by_user"), "username")}&nbsp;{this.props.i18n.t('at')}&nbsp;{moment
                  .utc(item.created)
                  .tz(this.props.userTimezone || "UTC")
                  .format("YYYY-MM-DD, HH:mm")}{" "}
                  &nbsp;{this.props.userShortTimezone || "UTC"}
              </span>)}
            <br/>
            {!!item.updated && (
              <span>
                {this.props.i18n.t('Updated by')}:  {get(get(item, "last_updated_by_user"), "username")}&nbsp;{this.props.i18n.t('at')}&nbsp;{moment
                  .utc(item.updated)
                  .tz(this.props.userTimezone || "UTC")
                  .format("YYYY-MM-DD, HH:mm")}{" "}
                  &nbsp;{this.props.userShortTimezone || "UTC"}
              </span>)}
          </p>
        )

      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("Actions"),
        render: (val, item) => (
          <div className={classes.actions}>
            <Button size="small" onClick={this.onRecordEdit(item)}>{this.props.i18n.t('View record')}</Button>
            &nbsp; &nbsp;
            {item.formEvent && ( <Button size="small" onClick={this.onEventEdit(item)}>{this.props.i18n.t('Edit event')}</Button>)}
          </div>
        ),
      },
    ];
    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("Quality Control")}
            </h3>

            {/*<div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>{this.props.i18n.t('SEARCH')}</b>
                <Search
                  placeholder={this.props.i18n.t('By name')}
                  enterButton={this.props.i18n.t('Search')}
                  size="large"
                  onSearch={this.onNameSearch}
                  value={nameSearch}
                  onChange={this.onNameChange}
                  style={{ maxWidth: '500px'}}
                />
              </label>

              <span className={classes.clearButton} onClick={this.clearFilters}>{this.props.i18n.t('Clear')}</span>
            </div>*/}

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {responseMessage && (
              <Alert
                type="success"
                message={responseMessage}
                className={classes.alert}
              />
            )}

            {/*{subjectIssuesCreatePermission && (
              <div>
                <Button type="primary" onClick={this.addCustomer}>
                  {this.props.i18n.t(
                    "NamespaceFinanceCustomersEditor:Add new issue"
                  )}
                </Button>
                <br />
                <br />
              </div>
            )}*/}

            <Table
              columns={columns}
              dataSource={customers}
              loading={isLoading}
              rowKey="id"
              onChange={this.handleTableChange}
              pagination={{
                onShowSizeChange: (current, size) => {
                  this.setState({ pageSize: size });
                },
                current: currentPage,
                total,
                pageSize,
                showSizeChanger: true,
                pageSizeOptions: ["10", "25", "50", "100"],
                position: 'both'
              }}
            />

            {/*{isLoading && <Icon type="loading" />}*/}

            <Modal
              visible={!!customerEdit}
              onCancel={this.onRecordEditHide}
              footer={null}
            >
              {customerEdit && (
                <QualityControlForm
                  {...customerEdit}
                  isNew={customerEdit && !customerEdit.id}
                  onSubmit={this.onRecordEditSubmit}
                  onCancel={this.onRecordEditHide}
                  sites={sites}
                />
              )}
            </Modal>

            {formEvent && (
              <FormBuilderCustomViewContainer
                site={formEvent.subject.site.id}
                slug={formEvent.custom_form.slug}
                subjectID={formEvent.subject.id}
                onCancel={() => {
                  this.setState({ formEvent: null });
                }}
                onSubmit={this.onEventEditSubmit}
              />
            )}
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  subjectIssuesCreatePermission: getSubjectIssuesCreatePermission(state),
  subjectIssuesDeletePermission: getSubjectIssuesDeletePermission(state),
  subjectIssuesUpdatePermission: getSubjectIssuesUpdatePermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(QualityControl))
);



// WEBPACK FOOTER //
// ./src/containers/QualityControl/QualityControl.js